import type { AdminDistrict, DistrictKind, LocalizedName, ReferenceItem } from "@/types";

import { BaseApi } from "./base.api";

export interface ReferenceItemPayload {
  name: LocalizedName;
  sortOrder?: number;
  isActive?: boolean;
}

export interface CreateReferenceItemPayload extends ReferenceItemPayload {
  /** Barqaror kalit: URL va profil yozuvlarida shu ishlatiladi. */
  code: string;
}

export interface CreateDistrictPayload extends CreateReferenceItemPayload {
  regionCode: string;
  type?: DistrictKind;
}

/**
 * Ma'lumotnomalar: soha, viloyat, tuman.
 *
 * O'CHIRISH YO'Q — backendda ham yo'q. Yozuvga profillar bog'langan,
 * shuning uchun keraksiz bo'lgani `isActive: false` bilan yopiladi.
 */
class AdminReferenceApi extends BaseApi {
  industries(includeInactive = true) {
    return this.request<ReferenceItem[]>("/admin/industries", {
      query: { includeInactive },
    });
  }

  createIndustry(payload: CreateReferenceItemPayload) {
    return this.request<ReferenceItem>("/admin/industries", { method: "POST", body: payload });
  }

  updateIndustry(id: string, payload: ReferenceItemPayload) {
    return this.request<ReferenceItem>(`/admin/industries/${id}`, {
      method: "PATCH",
      body: payload,
    });
  }

  regions(includeInactive = true) {
    return this.request<ReferenceItem[]>("/admin/regions", { query: { includeInactive } });
  }

  createRegion(payload: CreateReferenceItemPayload) {
    return this.request<ReferenceItem>("/admin/regions", { method: "POST", body: payload });
  }

  updateRegion(id: string, payload: ReferenceItemPayload) {
    return this.request<ReferenceItem>(`/admin/regions/${id}`, { method: "PATCH", body: payload });
  }

  districts(regionCode?: string, includeInactive = true) {
    return this.request<AdminDistrict[]>("/admin/districts", {
      query: { includeInactive, ...(regionCode ? { regionCode } : {}) },
    });
  }

  createDistrict(payload: CreateDistrictPayload) {
    return this.request<AdminDistrict>("/admin/districts", { method: "POST", body: payload });
  }

  /** Viloyat o'zgarmaydi — backend ham qabul qilmaydi. */
  updateDistrict(id: string, payload: ReferenceItemPayload & { type?: DistrictKind }) {
    return this.request<AdminDistrict>(`/admin/districts/${id}`, {
      method: "PATCH",
      body: payload,
    });
  }
}

export const adminReferenceApi = new AdminReferenceApi();
